module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_05-cb7a15e16687186b316678f0c9e35412.png";